import { useTranslation } from 'react-i18next';

import { PublicLayout } from 'components/layout';
import checkIcon from 'assets/images/check.svg';
import {
  ForgotUsernamePageStyled,
  BoldTextStyled,
  SuccessIconStyled,
  BigTextStyled,
} from './ForgotUsername.styles';

const EmailSent = ({ email }: { email: string }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user.auth.forgotUsername',
  });

  return (
    <PublicLayout>
      <ForgotUsernamePageStyled>
        <SuccessIconStyled src={checkIcon} />
        <BigTextStyled>{t('theLinkWasSentTo')}</BigTextStyled>
        <BoldTextStyled>{email}</BoldTextStyled>
      </ForgotUsernamePageStyled>
    </PublicLayout>
  );
};

export default EmailSent;
